import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propBool, propFunc, propShape, propStr, } from '../../../../../../../helpers/custom-prop-types';
import PlusCircleIcon from '../../../../../../Icon/Svg/PlusCircleIcon';
import Image from '../../../../../../Ui/Common/Image';
const RfpOneDescriptionFileImage = (props) => {
    const { driverTargetRef, isActiveDriverTarget, onClick, onClickDriverTarget, thumbnail, } = props;
    return (_jsx("div", Object.assign({ className: clsx('rfp-description-file-image', isActiveDriverTarget && 'is-driver-active'), onClick: isActiveDriverTarget ? onClickDriverTarget : onClick, ref: driverTargetRef, role: 'presentation' }, { children: _jsxs("div", Object.assign({ className: 'file_box' }, { children: [_jsx(Image, { alt: '', className: 'file_image', isObjectFitContain: true, onContextMenu: false, src: thumbnail, useImage: true }), _jsxs("div", Object.assign({ className: 'file_value' }, { children: [_jsx(PlusCircleIcon, { className: 'file_icon' }), _jsx("span", Object.assign({ className: 'file_text' }, { children: "\u63D0\u6848\u66F8\u3092\u898B\u308B" }))] }))] })) })));
};
RfpOneDescriptionFileImage.propTypes = {
    driverTargetRef: propShape(),
    isActiveDriverTarget: propBool(),
    onClick: propFunc().isRequired,
    thumbnail: propStr().isRequired,
};
RfpOneDescriptionFileImage.defaultProps = {
    driverTargetRef: null,
    isActiveDriverTarget: false,
};
export default RfpOneDescriptionFileImage;
